import {
  deleteSearchAlertPublic,
  getSearchAlertForDisplayLegacy
} from "./chunk-P726OJQE.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/unsubscribeSearchAlert/unSubscribeSearchAlert.ts
async function getSearchAlertForDisplay(searchAlertId, params, apiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, "getSearchAlertForDisplay");
  try {
    const searchAlert = await getSearchAlertForDisplayLegacy(searchAlertId, params, _apiConfig);
    return {
      status: "success",
      data: searchAlert
    };
  } catch (error) {
    apiConfig.onError?.(error);
    throw getErrorResult(error);
  }
}
async function deleteSearchAlertPublic2(searchAlertId, params, apiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, "deleteSearchAlertPublic");
  try {
    const searchAlert = await deleteSearchAlertPublic(searchAlertId, params, _apiConfig);
    return {
      status: "success",
      data: searchAlert
    };
  } catch (error) {
    apiConfig.onError?.(error);
    throw getErrorResult(error);
  }
}

export {
  getSearchAlertForDisplay,
  deleteSearchAlertPublic2 as deleteSearchAlertPublic
};
